import { createSlice } from '@reduxjs/toolkit';

import { HighRiskSupplementsCategory } from '@models/highRiskSupplementCategory';

import { handleGetRiskSupplementCategories } from './actions';
import { IRiskSupplementCategoriesState } from './slice.interface';

const initialState: IRiskSupplementCategoriesState = {
  data: null,
  isLoading: false,
  isReady: false,
  error: false,
};

export const riskSupplementCategoriesSlice = createSlice({
  name: 'risk-supplements-categories',
  initialState,
  reducers: {
    removeRiskSupplementCategories: state => {
      state.data = null;
      state.isLoading = false;
      state.isReady = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(
        handleGetRiskSupplementCategories.pending,
        (state: IRiskSupplementCategoriesState, action) => {
          state.isLoading = true;
          state.error = false;
        },
      )
      .addCase(
        handleGetRiskSupplementCategories.rejected,
        (state: IRiskSupplementCategoriesState, action) => {
          state.isLoading = false;
          state.error = true;
        },
      )
      .addCase(
        handleGetRiskSupplementCategories.fulfilled,
        (state: IRiskSupplementCategoriesState, action) => {
          state.isLoading = false;
          state.isReady = true;
          state.data = Array.isArray(action?.payload?.data)
            ? action.payload.data.map(item => new HighRiskSupplementsCategory(item))
            : null;
        },
      );
  },
});

export const { removeRiskSupplementCategories } = riskSupplementCategoriesSlice.actions;

export default riskSupplementCategoriesSlice.reducer;
